import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { create, setTitle } from '../../actions'
import Card from '../../components/Card'
import DynamicForm from '../../containers/DynamicForm'

const CreateSupplier = props => {
  const { setTitle } = props

  useEffect(() => {
    const topbar = {
      title: 'Crear Marca',
    }
    setTitle(topbar)

    // eslint-disable-next-line
  }, [])

  const path = 'products/colors'
  const action = 'CREATE_COLOR'
  const form = [
    {
      id: 1,
      name: 'name',
      label: 'Nombre',
      type: 'text',
      rules: {
        required: 'Este campo es requerido',
      },
      col: 12,
    },
  ]

  return (
    <Card title={'Información de marca'}>
      <DynamicForm path={path} action={action} form={form} />
    </Card>
  )
}

const mapDispatchToProps = {
  create,
  setTitle,
}

export default connect(null, mapDispatchToProps)(CreateSupplier)
